export default __webpack_public_path__ + "media/images/paylogos/gray/mastercard_secure@2x-593ee3c5d8594aa6a240dae4ae134f7a.png";